export enum LtvValueBasis {
  LowerOfPurchasePriceOrAppraisedValue = 'LowerOfPurchasePriceOrAppraisedValue',
  AppraisedValue = 'AppraisedValue',
  PurchasePrice = 'PurchasePrice',
}
